var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-1",attrs:{"color":_vm.color,"outlined":"","rounded":""},on:{"click":_vm.click}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }